import { FC, ReactNode } from 'react'
import classNames from 'classnames'

type TableContainerType = {
  children: ReactNode
  className?: string
}

const ContentContainer: FC<TableContainerType> = ({ children, className }) => {
  return (
    <div
      className={classNames(
        'px-5 py-4 shadow-2 rounded-lg' +
          ` ${className?.includes('bg-') ? '' : 'bg-white'}`,
        className,
      )}
    >
      {children}
    </div>
  )
}

export default ContentContainer
